/**
 * Textos de orientação (tooltips) da interface do cliente. Fonte única da
 * verdade: os componentes NUNCA escrevem o texto inline, sempre leem daqui.
 * Assim o teste garante que cada texto bate exatamente com o especificado.
 *
 * Regras: nenhum travessão; nenhum jargão de tecnologia (dizer "agente" ou
 * "assistente", nunca o nome de uma ferramenta).
 */
export const TOOLTIPS = {
  // Sidebar (item de menu)
  navImportar:
    'Suba sua carteira em planilha ou CSV. O agente lê o arquivo, organiza os contratos e aponta o que precisa de revisão.',
  navResultado:
    'O placar da sua carteira: valor em risco, comunicações feitas e a evolução do atraso desde que você entrou.',
  navRisco:
    'Sua carteira ordenada por urgência. Cada contrato tem uma nota de 0 a 100 recalculada todos os dias.',
  navComunicacoes:
    'Tudo que o agente escreveu para os seus compradores. Nada é enviado sem a sua aprovação.',
  navAjustes: 'Defina o tom das mensagens e o e-mail que aparece como remetente.',
  navAppCliente:
    'O aplicativo que os seus compradores usam. Aqui você ativa a marca, acompanha as obras e os boletos, e vê o que o cliente enxerga.',
  navObras:
    'O cronograma de cada empreendimento, etapa por etapa. Marcar uma etapa como concluída avisa os compradores por e-mail.',
  navBoletos:
    'Pedidos de segunda via feitos pelos compradores no aplicativo. Anexe o arquivo e ele chega na conversa e no e-mail do comprador.',

  // Tela /risco
  riscoScore:
    'Nota de 0 a 100. Quanto maior, mais perto do distrato. Calculada todos os dias a partir de reajuste chegando, atrasos e padrão de pagamento.',
  flagReajuste30d:
    'O aniversário deste contrato chega em até 30 dias. O reajuste do INCC vai mudar a parcela.',
  flagReajuste7d: 'Reajuste a uma semana. É a última janela boa para avisar o comprador.',
  flagParcelaAtrasada: 'Existe parcela vencida sem pagamento.',
  flagPadraoPiorando:
    'Dois ou mais atrasos nos últimos 90 dias. O comportamento está mudando para pior.',
  flagSaldoEstimado:
    'A planilha não trazia o saldo devedor. Estamos usando o valor do contrato até você corrigir.',
  flagIndiceInccFaltante:
    'Falta lançar o índice INCC de um mês necessário ao cálculo. Enquanto isso, o reajuste deste contrato não é calculado.',

  // Tela /comunicacoes
  comStatusSimulada:
    'Gerada em modo demonstração. Não foi enviada. Nos primeiros 14 dias, tudo fica em demonstração para você conhecer o agente.',
  comStatusAguardando: 'Pronta para sair. Só é enviada depois que você aprovar.',
  comStatusEnviada: 'Entregue ao comprador.',
  comStatusRejeitada: 'Você recusou este envio. Nada foi enviado.',
  comStatusFalhou: 'O envio não completou. O agente vai tentar de novo no próximo ciclo.',
  comAprovarLote: 'Aprova todas as mensagens selecionadas de uma vez.',

  // Tela /ajustes
  playbookConservador:
    'O agente só informa a situação e convida o comprador ao contato. Não oferece nada.',
  playbookModerado:
    'Além de informar, o agente pode oferecer diluir o reajuste em até 6 meses.',
  playbookAgressivo:
    'Diluição do reajuste e renegociação de atraso em até 3 parcelas. O agente negocia dentro desses limites.',
  ajustesRemetente:
    'Endereço que o comprador vê ao receber as mensagens. Vazio usa o padrão da plataforma.',

  // Tela /resultado
  kpiCarteiraRisco:
    'Soma do saldo devedor dos contratos com nota 40 ou mais. É o dinheiro que está pedindo atenção agora.',
  resultadoTendencia: 'Evolução da nota média da carteira. Caindo é bom: risco diminuindo.',
  resultadoAntesAgora: 'Taxa de atraso quando você entrou comparada com a de hoje.',

  // Tela /importar (revisão)
  revisaoContato:
    'Contrato sem telefone ou e-mail. O agente não consegue falar com este comprador até você completar.',
  revisaoSaldo:
    'Sem saldo devedor na planilha. Assumimos o valor do contrato até você corrigir.',
} as const;

export type TooltipKey = keyof typeof TOOLTIPS;
